import React from 'react'
import ContainerLayout from '../../../components/container-layout/ContainerLayout'
// import { RoutePath } from '../../../routes/Routes'
import StateComponents from '../../../components/state-component/StateComponents'
import { icons } from '../../../assets/icons/icons'
import { ManageState } from './manageState'
import TableCustom from '../../../components/table/tableCustom'
import { debouncedApiCall } from '../../../utils/app.utils'
import { NavigateFunction, useNavigate } from 'react-router-dom'
import NavigateListCustom from '../../../components/navigation/NavigationListCustom'
import { banner_type_data } from '../website-structure/content/enum/content.enum'
import { routeName } from '../../../routes/routeName'
import { useTranslation } from 'react-i18next'



type Props = {}

const PollVote: React.FC<Props> = ({ }: Props) => {
    const { t } = useTranslation();
    const navigate: NavigateFunction = useNavigate();
    const {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        handleRequestSort,
        sortBy,
        sortType,
        renderData,
        headCell,
        totalItems,
        data,
        setSearch,
        handleChangeDateRange,
        startDate,
        endDate,
        banner_type,
        set_banner_type,
        checkPermit,
        poll_type_data,
        set_id_poll_type,
        id_poll_type
    } = ManageState();



    return (
        <ContainerLayout
            titleName={t('โพลโหวต')}
            subTitle={t("กรุณาเลือกรายการที่ท่านต้องการ")}
            title=''
            // navigateContent={
            //     <NavigateListCustom
            //         navigateData={
            //             [
            //                 {
            //                     key: "โครงสร้างเว็บไซต์",
            //                     name: "โครงสร้างเว็บไซต์",
            //                     pathName: "",
            //                     disabled_match: true
            //                 },
            //                 {
            //                     key: "website_structure_content",
            //                     name: "จัดการเนื้อหา",
            //                     pathName: routeName.cms_website.website_structure_content,
            //                 },
            //             ]}
            //     />
            // }
            content={
                <div className='w-full'>
                    <StateComponents
                        otherProps={{
                            spacing: 2
                        }}
                        typeProps={[
                            {
                                seq: 1,
                                type: "TEXT_FIELD",
                                gridProps: {
                                    xs: 12,
                                    md: 3
                                },
                                fieldProps: {
                                    startAdornment: <span className='mr-4'><icons.SearchNormal /></span>,
                                    onChange: (e) => debouncedApiCall({ searchItem: e.target.value, setItem: setSearch }),
                                    placeholder: t("ค้นหาชื่อ"),
                                }
                            },
                            {
                                seq: 2,
                                type: "AUTO-COMPLETE",

                                gridProps: {
                                    xs: 12,
                                    md: 3,
                                },
                                fieldProps: {
                                    getOptionLabel: (op) => op?.poll_type || "",
                                    labelId: "id_poll_type",
                                    onChange: (_, val) => set_id_poll_type(val?.id_poll_type ?? null),
                                    placeholder: t('ทุกหมวดหมู่'),
                                    options: poll_type_data || [],
                                    value: poll_type_data?.find((x) => x?.id_poll_type === id_poll_type) || null,

                                }
                            },
                            {
                                seq: 3,
                                type: "DATE_RANGE2",
                                gridProps: {
                                    xs: 12,
                                    md: 3
                                },
                                fieldProps: {
                                    handleChange: handleChangeDateRange,
                                    value: {
                                        end_date: endDate,
                                        start_date: startDate
                                    },
                                    placeholder: t("ช่วงวันที่เปิดโหวต"),
                                }
                            },
                            {
                                seq: 4,
                                type: "BUTTON",
                                gridProps: {
                                    xs: 12,
                                    md: 3
                                },
                                // hidden: !checkPermit.isCreated,
                                fieldProps: {
                                    justifyContent: 'flex-end',
                                    buttonData: [
                                        {
                                            seq: 1,
                                            buttonProps: {
                                                onClick: () => navigate(routeName.cms_website.poll_vote_create)
                                            },
                                            key: "ADD",
                                            label: t("เพิ่มโพลโหวต"),
                                            type: "ADD"
                                        }
                                    ]
                                }
                            },
                        ]}
                    />

                    <section className='w-full mt-10'>
                        <TableCustom
                            tableMinWidth={1920}
                            tableFixedWidth
                            customScroll
                            page={page}
                            pageLimit={pageLimit}
                            sortBy={sortBy}
                            sortType={sortType}
                            headCells={headCell}
                            rowCount={totalItems}
                            rowsData={data?.map((data: any, i: any) => {
                                return renderData(data, i)
                            })}
                            onSort={handleRequestSort}
                            setPageLimit={(value: number) => setPageLimit(value)}
                            setPage={(value: number) => setPage(value)}
                        />
                    </section>
                </div>
            }
        />
    )
}

export default PollVote